import { useMemo } from 'react'
import config from 'config'
import { Tile } from '~/app/components/Tile'
import { Typography, Icon, Link, Box } from '@vp/swan'
import { getLocaleSelector, getMpvid } from '~/app/store/config'
import { useSelector } from 'react-redux'
import { useTranslations } from '~/app/features/Gallery/hooks/useTranslations'
import { buildFullyQualifiedVistaprintUrl } from '~/app/utils/vistaprintUrlBuilder'
import { useAnalytics } from '~/app/features/Gallery/hooks/useAnalytics'
import { ANALYTICS_PAGE_ZONE, ANALYTICS_CTA_VALUE, URL_TARGET, DESIGNERS_IMAGE } from '~/app/features/Gallery/components/PreviewArea/CareTile/constants'
import { ANALYTICS_EVENT_ACTIONS } from 'shared/constants'
import { useCareTileContent } from '~/app/features/Gallery/components/PreviewArea/CareTile/hooks/useCareTileContent'

export const CareTile = () => {
  const localize = useTranslations()
  const analytics = useAnalytics()
  const locale = useSelector(getLocaleSelector)
  const mpvId = useSelector(getMpvid)
  const { ctaText, captionText, headingText } = useCareTileContent(locale)
  const url = useMemo(
    () =>
      buildFullyQualifiedVistaprintUrl({
        path: URL_TARGET,
        locale,
        mpvId,
      }),
    [locale, mpvId],
  )

  const handleClick = (): void => {
    const eventDetailList = [window.location.pathname, URL_TARGET, ANALYTICS_PAGE_ZONE.CARE_TILE, ANALYTICS_CTA_VALUE.EXPERT_SERVICES_DESIGN_SERVICES_BRIEF]

    analytics.trackEvent({
      action: ANALYTICS_EVENT_ACTIONS.NAVIGATION_CLICKED,
      eventLabel: `Content:${ANALYTICS_PAGE_ZONE.CARE_TILE}`,
      eventDetail: eventDetailList.join(';'),
      navigationDetail: ANALYTICS_CTA_VALUE.EXPERT_SERVICES_DESIGN_SERVICES_BRIEF,
      route: config.client.segmentRoute,
    })
  }

  return (
    <Tile type="care-tile care-tile-dark" data-testid="care-tile">
      <Link
        aria-label={localize('CareTileHeading')}
        className="care-tile-action-area"
        href={url}
        referrerPolicy="no-referrer-when-downgrade"
        skin="unstyled"
        onClick={handleClick}
      >
        <Box className="care-tile-content">
          <Box px={{ lg: 4, xl: 7 }}>
            <Box
              py={{
                xs: 2,
                md: 3,
                lg: 5,
                xl: 7,
              }}
            >
              <img alt={localize('CareTileImageDescription')} className="care-tile-designer-img" src={DESIGNERS_IMAGE} />
            </Box>
            <Typography className="care-tile-header-text" fontWeight="bold">
              {headingText}
            </Typography>
            <Typography fontSize="small">{captionText}</Typography>
            <Box paddingTop={5}>
              <Typography className="care-tile-cta" fontWeight="bold">
                <span className="care-tile-cta-text">{ctaText}</span>
                <span>
                  <Icon darkMode iconType="arrowRight" />
                </span>
              </Typography>
            </Box>
          </Box>
        </Box>
      </Link>
    </Tile>
  )
}
